module.exports = __webpack_public_path__ + "img/quick_scan.340e5d44.png";